
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 128 128","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 68.3l102 58.9c3.3 1.9 7.5-.5 7.5-4.3V5.1c0-3.8-4.2-6.3-7.5-4.3l-102 58.9a4.9 4.9 0 000 8.6z","fill":"#4fa2b7"}}),_c('path',{staticClass:"st1",attrs:{"d":"M22.9 64h49.7"}}),_c('path',{attrs:{"d":"M52.8 64.9l23.3 13.5c.7.4 1.5-.1 1.5-.9v-27c0-.8-.8-1.3-1.5-.9L52.8 63.1c-.7.4-.7 1.4 0 1.8z","fill":"#fff"}}),_c('path',{staticClass:"st1",attrs:{"d":"M72.6 71H106M76 57h30"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/splitter.svg